import { patchCoreDataSecurityApplicationsBulkSlice } from './patch';

export const { requestPatchCoreDataSecurityApplicationsBulk, resetPatchCoreDataSecurityApplicationsBulk } =
	patchCoreDataSecurityApplicationsBulkSlice.asyncActionCreators;
